import React, { useState, useEffect } from 'react';
import {Page, Text, View, Document, Image,StyleSheet} from '@react-pdf/renderer';
import numeral from 'numeral';

const WaybillOrder = (props) => {
    if (props.loading) {
        return <Text>Loading...</Text>
    }

    const { order } = props;
    const items = order.items.map(i => (
        <Text>{i.quantity}x {i.name}  {i.description ? `- ${i.description}` : '' }</Text>
    ));

    return (
        <Document>
            <Page style={st.body}> 
                <View style={[st.bo.rlt,st.la.px16,st.la.pt4,st.la.jcc,st.fl.r]}>
                    <View style={[st.fl.f1]}>
                        <Image src={`/images/landing/sq_${order.courierCompany}.png`}/>
                    </View>
                    <View style={[st.fl.f5]}>
                        <Image src={`/images/landing/biteship-label.png`}/>
                    </View>
                    <View style={[st.fl.f1]}/> 
                </View>

                <View style={[st.bo.rlt,st.la.p8,st.la.jcc,st.fl.r]}>
                    <View style={[st.la.jcc]}>
                        <View style={[st.la.jcc,{alignItems:'center'}]}>
                            <Image
                                style={{ height:70, width:500}}
                                src={`https://v2018.api2pdf.com/zebra?format=code_39&apikey=00f93906-649e-4cd2-82ff-6a6a39b6c3bc&value=${order.courierWaybillId}`}
                            />
                            <Text style={st.te.b}>Nomor Resi - {order.courierWaybillId} </Text>
                        </View>
                    </View>
                </View>
                        
                {
                    order.receiverCODAmount > 0 ? 
                    <View style={[st.bo.rlt,st.la.p16,st.la.jcc,st.fl.r]}>
                        <View style={[st.la.jcc]}>
                            <View style={[st.la.jcc,{alignItems:'center'}]}>
                                <Text style={st.te.b}>Cash On Delivery (COD). Harga Barang + Ongkir: Rp. {numeral(order.receiverCODAmount).format("0,0")}</Text>
                            </View>
                        </View>
                    </View>
                    : null
                }

                <View style={st.serviceSection}>
                    <Text style={st.te.b}>Jenis Layanan </Text>
                    <Text style={st.te.b}>- </Text>
                    <Text style={st.te.b}>{order.courierType.toUpperCase()}</Text>
                </View>
                <View style={st.orderDetailsSection}>
                    <View style={{flex:2,borderRight:1,alignItems:'center',padding:12}}>
                        <Text style={[st.te.b,st.te.s12]}>Reference Number </Text>
                        <Image
                            style={{ height:50, width:250}}
                            src={`https://v2018.api2pdf.com/zebra?format=code_39&apikey=00f93906-649e-4cd2-82ff-6a6a39b6c3bc&value=${order.orderId}`}
                        />
                        <Text style={[st.te.b,st.te.s12]}>{order.orderId}</Text>
                    </View>
                    <View style={{flex:2}}>
                        <View style={[st.la.p8,st.bo.b,st.fl.r]}>
                            <View style={[st.fl.f3]}>
                                <Text>Quantity</Text>
                            </View>
                            <View style={[st.fl.f1]}>
                                <Text>:</Text>
                            </View>
                            <View style={[st.fl.f3]}>
                                <Text>{order.items.length} Pcs </Text>
                            </View>
                        </View>
                        <View style={[st.la.p8,st.bo.b,st.fl.r]}>
                            <View style={[st.fl.f3]}>
                                <Text>Weight</Text>
                            </View>
                            <View style={[st.fl.f1]}>
                                <Text>:</Text>
                            </View>
                            <View style={[st.fl.f3]}>
                                <Text>{order.weight/1000} Kg </Text>
                            </View>
                        </View>
                        <View style={[st.la.p8,st.fl.r]}>
                            <View style={[st.fl.f3]}>
                                <Text>Insurance</Text>
                            </View>
                            <View style={[st.fl.f1]}>
                                <Text>:</Text>
                            </View>
                            <View style={[st.fl.f3]}>
                                <Text>Rp 0,00 </Text>
                            </View>
                        </View>
                    </View>
                </View>

                <View style={[st.bo.rlb,st.fl.r,st.te.s14]}>
                    <View style={[st.fl.f1,st.la.p8,st.bo.r]}>
                        <Text>Pengirim</Text>
                        <View style={[st.fl.r]}>
                            <View style={[st.fl.f2]}>
                                <Text>Nama</Text>
                            </View>
                            <View style={[st.fl.f1]}>
                                <Text>:</Text>
                            </View>
                            <View style={[st.fl.f6]}>
                                <Text>{order.originName}</Text>
                            </View>
                        </View>
                        <View style={[st.fl.r]}>
                            <View style={[st.fl.f2]}>
                                <Text>Tlp</Text>
                            </View>
                            <View style={[st.fl.f1]}>
                                <Text>:</Text>
                            </View>
                            <View style={[st.fl.f6]}>
                                <Text>{order.originPhone}</Text>
                            </View>
                        </View>
                        <View style={[st.fl.r]}>
                            <View style={[st.fl.f2]}>
                                <Text>Alamat</Text>
                            </View>
                            <View style={[st.fl.f1]}>
                                <Text>:</Text>
                            </View>
                            <View style={[st.fl.f6]}>
                                <Text>{order.originLocation}</Text>
                            </View>
                        </View>
                        <View style={[st.fl.r]}>
                            <View style={[st.fl.f2]}>
                                <Text>Catatan</Text>
                            </View>
                            <View style={[st.fl.f1]}>
                                <Text>:</Text>
                            </View>
                            <View style={[st.fl.f6]}>
                                <Text>{order.originNote}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={[st.fl.f1,st.la.p8]}>
                        <Text>Penerima</Text>
                        <View style={[st.fl.r]}>
                            <View style={[st.fl.f2]}>
                                <Text>Nama</Text>
                            </View>
                            <View style={[st.fl.f1]}>
                                <Text>:</Text>
                            </View>
                            <View style={[st.fl.f6]}>
                                <Text>{order.receiverName}</Text>
                            </View>
                        </View>
                        <View style={[st.fl.r]}>
                            <View style={[st.fl.f2]}>
                                <Text>Tlp</Text>
                            </View>
                            <View style={[st.fl.f1]}>
                                <Text>:</Text>
                            </View>
                            <View style={[st.fl.f6]}>
                                <Text>{order.receiverPhone}</Text>
                            </View>
                        </View>
                        <View style={[st.fl.r]}>
                            <View style={[st.fl.f2]}>
                                <Text>Alamat</Text>
                            </View>
                            <View style={[st.fl.f1]}>
                                <Text>:</Text>
                            </View>
                            <View style={[st.fl.f6]}>
                                <Text>{order.receiverLocation}</Text>
                            </View>
                        </View>
                        <View style={[st.fl.r]}>
                            <View style={[st.fl.f2]}>
                                <Text>Catatan</Text>
                            </View>
                            <View style={[st.fl.f1]}>
                                <Text>:</Text>
                            </View>
                            <View style={[st.fl.f6]}>
                                <Text>{order.receiverNote}</Text>
                            </View>
                        </View>
                    </View>
                </View>

                <View style={[st.la.p8,st.fl.r,st.bo.rlb,st.te.s14]}>
                    <View style={[st.fl.f2]}>
                        <Text>Jenis Barang</Text>
                    </View>
                    <View style={[st.fl.f1]}>
                        <Text>:</Text>
                    </View>
                    <View style={[st.fl.f9]}>
                        {items}
                    </View>
                </View>

                <View style={[st.la.p8,st.fl.r,st.bo.rlb,st.te.s14]}>
                    <View style={[st.fl.f2]}>
                        <Text>Catatan</Text>
                    </View>
                    <View style={[st.fl.f1]}>
                        <Text>:</Text>
                    </View>
                    <View style={[st.fl.f9]}>
                        <Text>{order.note || 'Tidak Ada'}</Text>
                    </View>
                </View>

                <View style={[st.la.p8,st.bo.rlb,st.la.aic,st.te.s12]}>
                    <Text >Pengiriman melalui platform Biteship</Text>
                    <Text style={st.promo}>www.biteship.com</Text>
                </View>

            </Page>
        </Document>
    )
};


const st = StyleSheet.create({
    body: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 35,
    },
    la:{
        p2: { padding:2 },
        p4: { padding:4 },
        p8: { padding:8 },
        p16: { padding:16 },
        pt4: { paddingTop:4 },
        px2: { paddingLeft:2,paddingRight:2 },
        px4: { paddingLeft:4,paddingRight:4 },
        px8: { paddingLeft:8,paddingRight:8 },
        px16: { paddingLeft:16,paddingRight:16 },
        jcc:{justifyContent:'center'},
        aic:{alignItems:'center'}
    },
    bo:{
        l:{ borderLeft: 1},
        r:{ borderRight: 1},
        b:{ borderBottom: 1},
        t:{ borderTop: 1},
        rl:{ borderLeft:1,borderRight:1},
        rlt:{ borderLeft:1,borderRight:1,borderTop:1},
        rlb:{ borderLeft:1,borderRight:1,borderBottom:1}
    },
    fl:{
        r:{flexDirection:'row'},
        f1:{flex:1},
        f2:{flex:2},
        f3:{flex:3},
        f4:{flex:4},
        f5:{flex:5},
        f6:{flex:6},
        f7:{flex:7},
        f8:{flex:8},
        f9:{flex:9}
    },
    referenceBox:{
        borderRight:1
    },
    te: {
        b:{fontWeight:'bold'},
        s12:{fontSize:12},
        s14:{fontSize:14},
        s18:{fontSize:18},
        s24:{fontSize:24}
    },
    serviceSection: {
        border:1,
        padding:16,
        flexDirection:'row',
        justifyContent:'center'
    },
    orderDetailsSection: {
        borderLeft:1,
        borderRight:1,
        borderBottom:1,
        flexDirection:'row',
        justifyContent:'center'
    },
    promo:{
        color:'grey'
    }
});

export default WaybillOrder;
